<template>
    <QShare v-model="showSharePop" :showLoading="!sharePreviewImg" :src="sharePreviewImg" :shareInfo="shareConfig" :removeBase64Prefix="storeCommon.systemInfo.isAndroid" :statusBarHeight="storeCommon.statusBarHeight" @share="onShareSuccess" :typeList="typeList" systemBackName="sharePoster"></QShare>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue';
import { QShare } from '@q-front-npm/h5-ui';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { DrawCanvas, type IConfig } from '@qm-activity/common/assets/ts/canvas';
import iconSlogan from '@/assets/images/share-awards/slogan.png';
import qrcode from 'qrcode';
import { copyToClipboard } from '@qm-activity/common/assets/ts/utils';
import { useStore } from '@/store';
import shareImg from '@divide/assets/images/share-img.jpg';
import { supportPasswordVersionMap } from '@common/ts/const';
import { jsbReportV3 } from '@q-front-npm/jsbridge';
const store = useStore();
const storeCommon = useStoreCommon();
const getShareTypeList = () => {
    const { platform, appVersion, } = storeCommon.systemInfo;
    const isSupportPassword = appVersion >= supportPasswordVersionMap[platform];
    return isSupportPassword ? ['save', 'bookFriend', 'password', 'weixin', 'friend', 'qq', 'qzone'] : ['save', 'bookFriend', 'weixin', 'friend', 'qq', 'qzone'];
};
const typeList = getShareTypeList();
const props = withDefaults(
    defineProps<{
        value: boolean;
    }>(),
    {
        value: false,
    }
);
const emit = defineEmits<{(e: 'input', val: boolean): void }>();
const showSharePop = computed({
    get() {
        if (props.value) {
            saPopShow();
        }
        return props.value;
    },
    set(val) {
        emit('input', val);
    },
});

const shareConfig = {
    postTitle: '',
    postContent: '',
    topicTitle: '2026阅读马拉松',
    topicContent: '',
    topicId: '416741',
    from: '', // 产品定义帖子来源
};
const sharePreviewImg = ref('');
const SHARE_POSTER_WIDTH = 580;
const SHARE_POSTER_HEIGHT = 880;
const SHARE_BOTTOM_AREA_HEIGHT = 160;
const SHARE_QR_CODE_SIZE = 120;
const SHARE_QR_CODE_RIGHT_GAP = 24;
const SHARE_CANVAS_SCALE = 2;

const onShareSuccess = (data: Record<string, any>) => {
    console.log('-- onShareSuccess', data);
    if (data.shareType === 'password') {
        copyToClipboard(store.mainData.invite_code_pass || '');
        store.setPopManage('inviteCode', true);
    }
    saPopBtnClick(data.title);
};
const getPosterImg = async() => {
    const link = `https://api-marathon.wtzw.com/h5/activity/freereaderMarathon2026/sidePanel/divide?full_screen=3&code=${store.mainData.invite_code}`;
    const qrCodeImg = await qrcode.toDataURL(link, { width: SHARE_QR_CODE_SIZE, margin: 2, });
    const canvas = document.createElement('canvas');
    const width = SHARE_POSTER_WIDTH;
    const height = SHARE_POSTER_HEIGHT;
    const bottomY = height - SHARE_BOTTOM_AREA_HEIGHT;
    const qrCodeX = width - SHARE_QR_CODE_RIGHT_GAP - SHARE_QR_CODE_SIZE;
    const qrCodeY = bottomY + (SHARE_BOTTOM_AREA_HEIGHT - SHARE_QR_CODE_SIZE) / 2;
    canvas.width = width * SHARE_CANVAS_SCALE;
    canvas.height = height * SHARE_CANVAS_SCALE;
    const drawConfig: IConfig[] = [
        {
            type: 'img',
            src: shareImg,
            x: 0,
            y: 0,
            width,
            height,
        },
        {
            type: 'img',
            src: iconSlogan,
            x: 0,
            y: bottomY,
            width: width,
            height: height - bottomY,
        },
        // 二维码
        {
            type: 'img',
            src: qrCodeImg,
            x: qrCodeX,
            y: qrCodeY,
            width: SHARE_QR_CODE_SIZE,
            height: SHARE_QR_CODE_SIZE,
            radius: 6,
        }
    ];
    const drawCanvas = new DrawCanvas(canvas, drawConfig);
    const posterImg = await drawCanvas.createImage('jpeg');
    sharePreviewImg.value = posterImg;
};

getPosterImg();

const saPopShow = () => {
    jsbReportV3('2026_share-dialog_popup_show', {
        resource_page: `瓜分活动`,
        display_type: `瓜分活动`,
    });
};

const saPopBtnClick = (btn_name: string) => {
    jsbReportV3('2026_share-dialog_popup_click', {
        btn_name,
        resource_page: `瓜分活动`,
        display_type: `瓜分活动`,
    });
};
</script>
<style lang="scss" scoped></style>
